import React, { Component } from 'react';
import Select from 'react-select';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? 'white' : 'black',
  }),
};

class MultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.default,
    };
  }
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
  };
  render() {
    const { selectedOption } = this.state;
    let options = JSON.parse(this.props.data);
    return (
      <Select
        styles={customStyles}
        value={selectedOption}
        onChange={this.handleChange}
        options={options}
        isMulti
        name={this.props.col}
      />
    );
  }
}

export default MultiSelect;
